import React from "react";
import { func, string } from "prop-types";

import "./read-more-button.m.css";

const ReadMoreButton = ({ text, onClick, className }) => {
  const handleClick = () => {
    onClick && onClick();
    window.dispatchEvent(new CustomEvent("dh-content-expanded"));
  };
  return (
    <button onClick={handleClick} styleName="read-more-button" className={className}>
      {text}
    </button>
  );
};

ReadMoreButton.propTypes = {
  text: string,
  className: string,
  onClick: func
};

export default ReadMoreButton;
